import React from "react";

const DocumentsIcon = () => {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        //fillRule="evenodd"
        //clipRule="evenodd"
        d="M7.45866 0.5H1.62533C1.23855 0.5 0.867619 0.658035 0.594128 0.93934C0.320638 1.22064 0.166992 1.60218 0.166992 2V14C0.166992 14.3978 0.320638 14.7794 0.594128 15.0607C0.867619 15.342 1.23855 15.5 1.62533 15.5H10.3753C10.7621 15.5 11.133 15.342 11.4065 15.0607C11.68 14.7794 11.8337 14.3978 11.8337 14V5L7.45866 0.5ZM6.72949 5.74999V1.99999L10.3753 5.74999H6.72949ZM8.24646 11.6667H9.63922C9.90012 11.6667 10.1114 11.8718 10.1114 12.125C10.1114 12.3782 9.90012 12.5833 9.63922 12.5833H8.24646C7.76095 12.5833 7.32356 12.3215 7.10604 11.8998C7.01897 11.7303 6.86727 11.7131 6.80588 11.7131C6.74449 11.7131 6.59279 11.73 6.51015 11.8904L6.28378 12.3298C6.24458 12.4059 6.1843 12.47 6.1097 12.5147C6.0351 12.5594 5.94913 12.5831 5.86144 12.583C5.85022 12.583 5.8393 12.5825 5.82779 12.5816C5.63743 12.5687 5.47363 12.4455 5.41371 12.2697L4.91699 10.8242L4.60385 11.7374C4.43001 12.2433 3.94333 12.5833 3.39378 12.5833H3.02811C2.7672 12.5833 2.55588 12.3782 2.55588 12.125C2.55588 11.8718 2.7672 11.6667 3.02811 11.6667H3.39378C3.53633 11.6667 3.66265 11.5784 3.70781 11.4472L4.24467 9.88202C4.34206 9.60101 4.61182 9.41195 4.91699 9.41195C5.22217 9.41195 5.49192 9.60072 5.58902 9.88202L5.99868 11.0748C6.58217 10.6111 7.5939 10.797 7.94659 11.4805C8.00621 11.5968 8.1225 11.6667 8.24646 11.6667Z"
        fill="#30323A"
      />
    </svg>
  );
};

export default DocumentsIcon;
